export const DefaultConfigModuleConstant = {
    WALLET_THRESHOLD_DEFAULTS_PENDING: 'WALLET_THRESHOLD_DEFAULTS_PENDING',
    WALLET_THRESHOLD_DEFAULTS_SUCCESS: 'WALLET_THRESHOLD_DEFAULTS_SUCCESS',
    WALLET_THRESHOLD_DEFAULTS_FAILURE: 'WALLET_THRESHOLD_DEFAULTS_FAILURE',
    CONFIGURATION_DEFAULTS_PENDING: 'CONFIGURATION_DEFAULTS_PENDING',
    CONFIGURATION_DEFAULTS_SUCCESS: 'CONFIGURATION_DEFAULTS_SUCCESS',
    CONFIGURATION_DEFAULTS_FAILURE: 'CONFIGURATION_DEFAULTS_FAILURE',
};
